<!-- 字典管理-->
<template>
<div>
  <x-dictionaries></x-dictionaries>
</div>
</template>

<script>
import { dictionaries } from 'ant-design-vue-admin-x';
export default {
  name: 'dictionaries',
  components: { XDictionaries: dictionaries }
};
</script>
